import { RepositoryDocumentsPage } from "@/components/revenueos/RepositoryDocumentsPage";

export default function CustomerPresentations() {
  return (
    <RepositoryDocumentsPage
      category="customer_presentation"
      title="Customer Presentations"
      description="Decks presented to customers, shared across every partner and admin."
    />
  );
}
